import { Timestamp } from "firebase/firestore";

export const truncateText = (
  text: string,
  startChars: number,
  endChars: number
) => {
  if (!text) return "";
  const truncatedText =
    text.length > startChars + endChars
      ? text.substring(0, startChars) +
      "....." +
      text.substring(text.length - endChars)
      : text;
  return truncatedText;
};

export function formatRelativeTime(timestamp: any): string {
  const currentTime: any = Math.floor(Date.now() / 1000); // Current time in seconds
  
  let timestampInSeconds: number;
  
  // Check if timestamp is a Firebase timestamp object with seconds property
  if (timestamp && typeof timestamp === 'object' && timestamp.seconds !== undefined) {
    timestampInSeconds = timestamp.seconds;
  } 
  // Check if timestamp is a string in format "YYYY-MM-DD HH:MM:SS+XX"
  else if (typeof timestamp === 'string' && timestamp.match(/^\d{4}-\d{2}-\d{2}/)) {
    const date = new Date(timestamp);
    if (!isNaN(date.getTime())) {
      timestampInSeconds = Math.floor(date.getTime() / 1000);
    } else {
      return "Invalid date";
    }
  }
  // Handle regular numeric timestamp
  else {
    timestampInSeconds = Math.floor(timestamp);
    if (isNaN(timestampInSeconds)) {
      return "Invalid date";
    }
  }
  
  const secondsAgo = currentTime - timestampInSeconds;

  if (secondsAgo < 60) {
    return secondsAgo + " sec" + (secondsAgo !== 1 ? "s" : "") + " ago";
  }

  const minutesAgo = Math.floor(secondsAgo / 60);
  if (minutesAgo < 60) {
    return minutesAgo + " min" + (minutesAgo !== 1 ? "s" : "") + " ago";
  }

  const hoursAgo = Math.floor(minutesAgo / 60);
  if (hoursAgo < 24) {
    return hoursAgo + " hour" + (hoursAgo !== 1 ? "s" : "") + " ago";
  }

  const daysAgo = Math.floor(hoursAgo / 24);
  if (daysAgo < 30) {
    return daysAgo + " day" + (daysAgo !== 1 ? "s" : "") + " ago";
  }

  const monthsAgo = Math.floor(daysAgo / 30);
  if (monthsAgo < 12) {
    return monthsAgo + " month" + (monthsAgo !== 1 ? "s" : "") + " ago";
  }

  const yearsAgo = Math.floor(monthsAgo / 12);
  return yearsAgo + " year" + (yearsAgo !== 1 ? "s" : "") + " ago";
}

export function parseISODateTime(dateTimeString: string | number): number {
  if (typeof dateTimeString === 'number') {
    return dateTimeString;
  }
  
  try {
    const date = new Date(dateTimeString);
    if (!isNaN(date.getTime())) {
      return Math.floor(date.getTime() / 1000); // Convert to seconds
    }
  } catch (error) {
    console.error("Error parsing date:", error);
  }
  
  return 0; // Return 0 if parsing fails
}

export const convertFirebaseTimestamp = (
  firebaseTimestamp: any
): string | null => {
  if (!firebaseTimestamp || !(firebaseTimestamp instanceof Timestamp)) {
    return null; // Return null or handle the error as per your requirement
  }

  const date = firebaseTimestamp.toDate();

  const options: Intl.DateTimeFormatOptions = {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  };
  const formattedDate: string = date.toLocaleDateString("en-US", options);

  return formattedDate;
};
